import { CODInput } from "../../ui/CODinput";
import { Select } from "../../ui/Select";

const buttonStyles = {
  save: {
    padding: "8px 16px",
    borderRadius: "4px",
    border: "none",
    background: "#07b1b0",
    color: "#fff",
    cursor: "pointer",
  },
  cancel: {
    padding: "8px 16px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    background: "#fff",
    color: "#333",
    cursor: "pointer",
  },
};

const buttonContainerStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "10px",
  padding: "10px",
  marginTop: "10px",
};

const AddCurrencyForm = ({ formData, onChange, onSubmit, onCancel }) => {
  return (
    <form>
      <CODInput
        label="Currency Code"
        type="text"
        name="currencyCode"
        value={formData.currencyCode}
        onChange={onChange}
        required
      />
      <CODInput
        label="Currency Name"
        name="currencyName"
        value={formData.currencyName}
        onChange={onChange}
        required
      />
      <CODInput
        label="Currency Symbol"
        name="currencySymbol"
        value={formData.currencySymbol}
        onChange={onChange}
        required
      />
      <CODInput
        label="Country"
        name="country"
        value={formData.country}
        onChange={onChange}
        required
      />
     

      <div style={buttonContainerStyle}>
        <button type="submit" style={buttonStyles.save} onClick={onSubmit}>
          Save
        </button>
        <button type="button" onClick={onCancel} style={buttonStyles.cancel}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default AddCurrencyForm;
